<template>
    <small class="info--text" >{{ coordenadas }}</small>
</template>

<script>
    import Vue from 'vue';

    export default Vue.extend({
        name: 'CoordenadasComponent',
        computed: {
          coordenadas: function(){
            if (this.params.data.ubicacion.coordinates) {
              return this.params.data.ubicacion.coordinates[1].toFixed(4) + ',' + this.params.data.ubicacion.coordinates[0].toFixed(4)
            } else {
              return 'lat,lon'
            }
          }
        },
    });
</script>

<style >
</style>



// WEBPACK FOOTER //
// src/components/shared/CoordenadasComponent.vue